import React from 'react';
import Footer from '../common/Footer';
import Header from '../common/Header';

const LegalNotice = () => {
  return (
    <>
      <Header currentAnchor={''} links />
      <div className="document">
        <div className="container">
          <h1>MENTIONS LÉGALES</h1>
          <p>
            Le Site Internet www.cleanbill.fr est édité par la société CleanBill :
            <ul>
              <li>Raison sociale : SAS Clean Bill</li>
              <li>Adresse : 39 B chemin de l’Usclade 30340 SAINT-PRIVAS-DES- VIEUX</li>
              <li>Siret : 838090496 00012</li>
              <li>Numéro TVA intracommunautaire : FR 72 838090496</li>
              <li>RCS : Nîmes 12/03/2018</li>
              <li>Capital : 30 000 €</li>
            </ul>

            et est hébergé par la société Amazon Web Services (<a href="http://aws.amazon.com">http://aws.amazon.com</a>):
            <ul>
              <li>Amazon Web Services LLC, P.O. Box 81226, Seattle, WA 98108-1226 - USA</li>
            </ul>

            Le Site Internet www.cleanbill.fr a été réalisé par la société toHero (<a href="https://www.tohero.fr/">https://www.tohero.fr/</a>) :
            <ul>
              <li>95 Rue Pierre Flourens, 34090 Montpellier</li>
            </ul>
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default LegalNotice;
